import React from 'react';

const HomePageStory = () => {
    return (
        <section className="container story">
            <p className="text-justify">I am a Suffolk based artist working with water-based media and Collage. Watercolour has always been my main medium of choice, preferred for its immediacy, spontaneity, and for the way that the colours come alive when the light shines through. My recent experimentation with collage, alongside watercolour, using my own hand-painted papers allows me to build a fabric of texture and pattern to develop my observations and also take my work into a more abstract direction.</p>
        </section>
    );
};

export default HomePageStory;



// WEBPACK FOOTER //
// ./src/components/homePage/HomePageStory.js